const NODE_ID_RE =
  /\s*<!--\s*@id\s+([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\s*-->/i;
const HTML_COMMENT_RE = /\s*<!--[\s\S]*?-->/g;

/**
 * Strip a trailing `<!-- @id <uuid> -->` comment from a lead-in line and
 * return both the cleaned line and the extracted UUID. If no comment is
 * present, returns the line unchanged and nodeId = undefined.
 */
export function extractNodeId(line: string): { stripped: string; nodeId: string | undefined } {
  const m = NODE_ID_RE.exec(line);
  if (!m) return { stripped: line, nodeId: undefined };
  return { stripped: line.replace(NODE_ID_RE, '').trimEnd(), nodeId: m[1].toLowerCase() };
}

export function stripHtmlComments(line: string): string {
  return line.replace(HTML_COMMENT_RE, '').trimEnd();
}
